import * as styles from "./YearPickerHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";
import { useLingui } from "@lingui/react/macro";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerHeaderProps } from "./YearPicker.types";

export function YearPickerHeader({
  className,
}: YearPickerHeaderProps): JSX.Element {
  const { t } = useLingui();

  const { viewDecade, min, max, goToDecade } = useYearPickerContext();

  const last = viewDecade + 9;

  return (
    <div
      data-slot="year-picker-header"
      className={clsx(styles.header, className)}
    >
      <button
        type="button"
        className={styles.navButton}
        onClick={() => goToDecade(-1)}
        disabled={null !== min && viewDecade <= min}
        aria-label={t`Previous decade`}
      >
        <Icon name="ChevronLeft" size="sm" />
      </button>

      <span className={styles.decade} aria-live="polite">
        {viewDecade} – {last}
      </span>

      <button
        type="button"
        className={styles.navButton}
        onClick={() => goToDecade(1)}
        disabled={null !== max && last >= max}
        aria-label={t`Next decade`}
      >
        <Icon name="ChevronRight" size="sm" />
      </button>
    </div>
  );
}
